import Vue from 'vue'

Vue.filter('camelcase', function (value) {
  if (!value) return ''
  // converting all characters to lowercase
  value = value.charAt(0).toUpperCase() + value.slice(1);
  return value
})
